import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Menu from "../Menu";
import { useNavigate, useParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import {
  Navigation,
  Pagination,
  Autoplay,
  Mousewheel,
  Keyboard,
} from "swiper/modules";
import useApiUrls from "../../useApiUrls";
import DialogBox from "../../components/DialogBox";
import CopyCommand from "../../components/CopyCommand";

const ShowDqrImages = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [data, setData] = useState([]); // categories [{key,value}]
  const fileInputRefs = useRef({});
  const [DQRImage, setDQRImage] = useState([]); // [{categoryid, imagedata: [...]}]
  const [message, setMessage] = useState("");
  const [initialSlide, setInitialSlide] = useState(0);
  const [showModal, setShowModal] = useState(false);

  const token = getCookie("token");
  const userid = getCookie("userid");

  const [structureRows, setStructureRows] = useState([]); // rows from structure API
  const [showStructureDialog, setShowStructureDialog] = useState(false);

  const [modalImages, setModalImages] = useState([]);
  const [modalForText, setModalForText] = useState(false);
  const [currentText, setCurrentText] = useState("");
  const [currentFullData, setCurrentFullData] = useState({});
  const [currentIdForEditText, setCurrentIdForEditText] = useState({});

  const { getUrlByOperation } = useApiUrls();

  useEffect(() => {
    fetchData();
    fetchDQRStrucureImage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(
        "https://api.dqr-display-tms.eventum.co.in/api/DQRCategoryOperation/GetDistinct/all",
        {
          headers: {
            accept: "text/plain",
            "X-Authorization": token,
            UserId: userid,
          },
        }
      );
      if (response.data && Array.isArray(response.data.data)) {
        setData(response.data.data.sort((a, b) => a.key - b.key));
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const fetchDQRStrucureImage = async () => {
    try {
      const requestBody = {
        dqrid: id,
        returntype: "structure",
        ispageload: false,
        pagesize: 1000,
        currentpageno: 0,
        withoutpagination: false,
        pagedirection: "first",
      };
      const response = await axios.post(
        "https://api.dqr-display-tms.eventum.co.in/api/DQRInfoOperation/Search",
        requestBody,
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "Content-Type": "application/json-patch+json",
          },
        }
      );
      if (response.data?.data?.categorydata) {
        setDQRImage(response.data.data.categorydata);
      }
    } catch (error) {
      console.error("Error fetching images:", error);
    }
  };

  const handleFileChange = async (e, dqrCategoryId, name, remark) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;

    try {
      const formData = new FormData();
      formData.append("DQRCategoryId", dqrCategoryId);
      formData.append("Name", name || "");
      formData.append("remark", remark || "");
      formData.append("active", true);
      formData.append("DQRId", id);

      Array.from(files).forEach((file) => formData.append("File", file));

      const url =
        "https://api.dqr-display-tms.eventum.co.in/api/DQRInfoOperation/Insert";
      await axios.post(url, formData, {
        headers: {
          "X-Authorization": token,
          UserId: userid,
          "Content-Type": "multipart/form-data",
        },
      });

      setMessage("Image added successfully!");
      fetchData();
      fetchDQRStrucureImage();
    } catch (error) {
      console.error("Error uploading file:", error);
      setMessage("Failed to upload file.");
    }
  };

  const handleButtonClick = (itemKey) => {
    if (fileInputRefs.current[itemKey]) {
      fileInputRefs.current[itemKey].click();
    }
  };

  // FIXED: proper GET call (no body), no stray space in URL, shows dialog with response fields
  const fetchDQRStrucureData = async (dqrcategoryid) => {
    try {
      const url = `https://api.dqr-display-tms.eventum.co.in/api/DQRImageStructureOperation/Get/DqrId/DqrCategoryId/${id}/${dqrcategoryid}`;
      const res = await axios.get(url, {
        headers: {
          accept: "text/plain",
          "X-Authorization": token,
          UserId: userid,
        },
      });

      const rows = Array.isArray(res.data?.data) ? res.data.data : [];
      setStructureRows(rows);
      setShowStructureDialog(true);
    } catch (error) {
      console.error("Error fetching DQR structure:", error);
      setStructureRows([]);
      setShowStructureDialog(true);
    }
  };

  const handleDeleteStructure = async (categoryId) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this record? This action cannot be undone."
    );
    if (!confirmDelete) return;

    try {
      const requestBody = { dqrId: id, dqrCategoryId: categoryId };
      const response = await axios.post(
        "https://api.dqr-display-tms.eventum.co.in/api/DQRImageStructureOperation/Delete/DqrId/DqrCategoryId",
        requestBody,
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "Content-Type": "application/json-patch+json",
          },
        }
      );

      if (response.data?.responsestatus === "SUCCESS") {
        setMessage("Data deleted successfully!");
      } else {
        setMessage(
          `Failed to delete: ${
            response.data?.errormsg || "Unknown server response"
          }`
        );
      }
      // Refresh from server
      fetchDQRStrucureImage();
    } catch (error) {
      console.error("Error deleting structure:", error);
      setMessage("Failed to delete data. Please try again.");
    }
  };

  const handleUpdatePop = (dqrcategoryid) => {
    navigate(`/update-dqr-image/${id}/${dqrcategoryid}`);
  };

  const handleIamgePreview = (dqrcategoryid) => {
    navigate(`/preview-images/${id}/${dqrcategoryid}`);
  };

  const handleImageClick = (images, imageindex) => {
    setModalImages(images || []);
    setInitialSlide(imageindex || 0);
    setShowModal(true);
  };

  const handleDeleteImage = async (imgId) => {
    try {
      const DQRInfoDelete = getUrlByOperation("DQRInfoDelete");
      const response = await axios.post(
        DQRInfoDelete,
        { id: imgId },
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "Content-Type": "application/json-patch+json",
          },
        }
      );

      if (response.data?.responsestatus === "SUCCESS") {
        setMessage("Data deleted successfully!");
        fetchDQRStrucureImage();
      } else {
        setMessage(
          `Failed to delete: ${
            response.data?.errormsg || "Unknown server response"
          }`
        );
      }
    } catch (error) {
      console.error("Error deleting item:", error);
      setMessage("Failed to delete data. Please try again.");
    }
  };

  const handleEditText = async (editableTexts) => {
    setModalForText(false);

    const updateData = {
      id: currentIdForEditText.id,
      active: true,
      name: editableTexts,
      remark: currentFullData?.catalogstructurename ?? "",
      Position: currentIdForEditText.position,
    };

    try {
      const DQRInfoUpdate = getUrlByOperation("DQRInfoUpdate");
      await axios.post(DQRInfoUpdate, updateData, {
        headers: {
          "X-Authorization": token,
          UserId: userid,
          "Content-Type": "application/json-patch+json",
        },
      });
      setMessage("Dqr updated successfully!");
      fetchDQRStrucureImage();
    } catch (error) {
      console.error("Error updating Dqr:", error);
      setMessage("Failed to update Dqr.");
    }
  };

  const handleChange = (e) => setCurrentText(e.target.value);

  const handlePreviw = () => {
    const previewUrl = `/dqr-images-preview/${id}`;
    window.open(previewUrl, "_blank");
  };

  const handleAddPop = () => navigate(`/add-image-in-dqr`);

  return (
    <>
      <Menu />

      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="d-flex justify-content-between align-items-center w-100">
                  <h1 className="mb-0">Images</h1>
                  <div className="ms-auto">
                    <button
                      type="button"
                      className="btn btn-primary me-2"
                      onClick={handlePreviw}
                    >
                      Show preview
                    </button>
                    {/* <button
                      type="button"
                      className="btn btn-success"
                      onClick={handleAddPop}
                    >
                      Add DQR Images
                    </button> */}
                  </div>
                </div>
              </div>
            </div>
          </section>

          <div className="card-body table-responsive p-0">
            <table className="table table-hover text-nowrap">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Images</th>
                  <th>Add Image</th>
                  <th>Actions</th>
                </tr>
              </thead>

              <tbody>
                {data.map((item) => (
                  <tr key={item.key}>
                    <td>{item.key}</td>
                    <td>{item.value}</td>

                    <td>
                      {DQRImage.filter(
                        (dqrItem) => dqrItem.categoryid === item.key
                      ).map((filteredItem) => (
                        <div key={filteredItem.categoryid}>
                          {filteredItem.imagedata.length > 4 ? (
                            <Swiper
                              style={{ height: "150px", width: "700px" }}
                              slidesPerView={4}
                              spaceBetween={10}
                              autoplay={{
                                delay: 2500,
                                disableOnInteraction: false,
                              }}
                              navigation
                              pagination={{ clickable: true }}
                              modules={[Autoplay, Navigation, Pagination]}
                            >
                              {filteredItem.imagedata.map(
                                (image, imgIndex) => (
                                  <SwiperSlide key={image.id}>
                                    <div style={thumbWrapStyle}>
                                      <img
                                        src={image.filepath}
                                        alt={image.name}
                                        id={image.id}
                                        style={thumbImageStyle}
                                        onClick={() =>
                                          handleImageClick(
                                            filteredItem.imagedata,
                                            imgIndex
                                          )
                                        }
                                      />
                                      <i
                                        className="fas fa-trash-alt"
                                        style={trashIconStyle}
                                        onClick={() =>
                                          handleDeleteImage(image.id)
                                        }
                                        title="Delete"
                                      />
                                      <label
                                        style={thumbLabelStyle}
                                        onClick={() => {
                                          setModalForText(true);
                                          setCurrentText(image.name);
                                          setCurrentFullData(filteredItem);
                                          setCurrentIdForEditText(image);
                                        }}
                                      >
                                        {image.name}
                                      </label>
                                    </div>
                                  </SwiperSlide>
                                )
                              )}
                            </Swiper>
                          ) : (
                            <div style={{ display: "flex", gap: 10 }}>
                              {filteredItem.imagedata.map(
                                (image, imgIndex) => (
                                  <div style={{ position: "relative" }} key={image.id}>
                                    <img
                                      src={image.filepath}
                                      alt={image.name}
                                      style={thumbImageStyle}
                                      onClick={() =>
                                        handleImageClick(
                                          filteredItem.imagedata,
                                          imgIndex
                                        )
                                      }
                                    />
                                    <i
                                      className="fas fa-trash-alt"
                                      style={trashIconStyle}
                                      onClick={() => handleDeleteImage(image.id)}
                                      title="Delete"
                                    />
                                    <label
                                      style={thumbLabelStyle}
                                      onClick={() => {
                                        setModalForText(true);
                                        setCurrentText(image.name);
                                        setCurrentFullData(filteredItem);
                                        setCurrentIdForEditText(image);
                                      }}
                                    >
                                      {image.name}
                                    </label>
                                  </div>
                                )
                              )}
                            </div>
                          )}
                        </div>
                      ))}
                    </td>

                    <td>
                      <input
                        type="file"
                        style={{ display: "none" }}
                        ref={(el) => (fileInputRefs.current[item.key] = el)}
                        onChange={(e) => {
                          const selectedData = DQRImage.find(
                            (dqrItem) => dqrItem.categoryid === item.key
                          );

                          if (selectedData) {
                            handleFileChange(
                              e,
                              selectedData.categoryid,
                              selectedData.dqrname || "",
                              selectedData.addqr || ""
                            );
                          } else {
                            handleFileChange(
                              e,
                              item.key,
                              item.value || "",
                              ""
                            );
                          }
                        }}
                        multiple
                      />
                      <button
                        className="btn btn-primary"
                        onClick={() => handleButtonClick(item.key)}
                      >
                        +
                      </button>
                    </td>

                    <td>
                      <button
                        type="button"
                        className="btn btn-success mb-2 w-20"
                        onClick={() => fetchDQRStrucureData(item.key)}
                      >
                        View
                      </button>
                      <br />
                      <button
                        className="btn btn-danger mb-2 w-20"
                        style={{ marginLeft: 2 }}
                        onClick={() => handleDeleteStructure(item.key)}
                      >
                        Delete
                      </button>
                      <br />
                      <button
                        className="btn btn-warning mb-2 w-20"
                        style={{ marginLeft: 2 }}
                        onClick={() => handleUpdatePop(item.key)}
                      >
                        Update
                      </button>
                      <br />
                      <button
                        className="btn btn-primary mb-2 w-20"
                        style={{ marginLeft: 2 }}
                        onClick={() => handleIamgePreview(item.key)}
                      >
                        Preview
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {message ? (
              <div style={{ padding: "10px 15px" }}>
                <small>{message}</small>
              </div>
            ) : null}
          </div>
        </div>
      </div>

      {/* Edit name modal */}
      {modalForText && (
        <div style={modalStyle}>
          <div style={modalContentStyle}>
            <input
              type="text"
              value={currentText}
              onChange={handleChange}
              style={{ width: "100%", marginBottom: 10 }}
            />
            <br />
            <button
              className="btn btn-warning"
              style={{ marginLeft: 2 }}
              onClick={() => setModalForText(false)}
            >
              Cancel
            </button>
            <button
              className="btn btn-success"
              style={{ marginLeft: 8 }}
              onClick={() => handleEditText(currentText)}
            >
              Edit
            </button>
          </div>
        </div>
      )}

      {/* Image preview modal */}
      {showModal && (
        <div style={modalStyle}>
          <div style={modalContentStyle}>
            <Swiper
              style={{ height: "100%", width: 500, marginLeft: 0 }}
              slidesPerView={1}
              spaceBetween={10}
              cssMode
              navigation
              pagination
              mousewheel
              keyboard
              initialSlide={initialSlide}
              modules={[Navigation, Pagination, Mousewheel, Keyboard]}
              className="mySwiper"
            >
              {Array.isArray(modalImages) && modalImages.length > 0 ? (
                modalImages.map((image, imaIndex) => (
                  <SwiperSlide key={imaIndex}>
                    <div style={{ ...containerStyle, textAlign: "center" }}>
                      <img style={imageStyle} src={image.filepath} alt={image.name} />
                      <div
                        style={{
                          marginTop: 10,
                          display: "flex",
                          justifyContent: "center",
                          gap: 10,
                        }}
                      >
                        <button
                          className="btn btn-warning"
                          onClick={() => setShowModal(false)}
                        >
                          Close
                        </button>
                        <CopyCommand path={image.filepath} />
                      </div>
                    </div>
                  </SwiperSlide>
                ))
              ) : (
                <p>No images to display</p>
              )}
            </Swiper>
          </div>
        </div>
      )}

      {/* Structure dialog (prints API data in dialog box) */}
      {showStructureDialog && (
        <DialogBox
          currentText={
            <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
              {structureRows.length === 0 ? (
                <span>No structure data.</span>
              ) : (
                structureRows.map((item, idx) => (
                  <div
                    key={idx}
                    style={{
                      border: "1px solid #eee",
                      borderRadius: 8,
                      padding: 12,
                      marginBottom: 8,
                    }}
                  >
                    <label><b>ID:</b> {item.id}</label><br/>
                    <label><b>DQR ID:</b> {item.dqrid}</label><br/>
                    <label><b>Category ID:</b> {item.dqrcategoryid}</label><br/>
                    <label><b>Category Name:</b> {item.categoryname}</label><br/>
                    <label><b>DQR Name:</b> {item.dqrname}</label><br/>
                    <label><b>Example Text:</b> {item.exampletext}</label><br/>
                    <label><b>Image Position X:</b> {item.imagepositionx}</label><br/>
                    <label><b>Image Position Y:</b> {item.imagepositiony}</label><br/>
                    <label><b>Image Width:</b> {item.imagewidth}</label><br/>
                    <label><b>Image Height:</b> {item.imageheight}</label><br/>
                    <label><b>Center:</b> {item.center}</label><br/>
                    <label><b>Font Family:</b> {item.fontfamily}</label><br/>
                    <label><b>Font Size:</b> {item.fontsize}</label><br/>
                    <label><b>Font Color:</b> {item.fontcolor}</label><br/>
                    <label><b>Text Position X:</b> {item.textpositionx}</label><br/>
                    <label><b>Text Position Y:</b> {item.textpositiony}</label><br/>
                    <label><b>Remark:</b> {item.remark}</label><br/>
                    <label><b>Created:</b> {item.createddate}</label><br/>
                    <label><b>Last Modified:</b> {item.lastmodifieddate}</label><br/>
                  </div>
                ))
              )}
            </div>
          }
          setModalForText={() => {
            setShowStructureDialog(false);
            setStructureRows([]);
          }}
        />
      )}
    </>
  );
};

export default ShowDqrImages;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
}

/* ---------- styles ---------- */
const modalStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0,0,0,0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
};

const modalContentStyle = {
  backgroundColor: "white",
  padding: 20,
  borderRadius: 8,
  textAlign: "center",
  maxWidth: 560,
  width: "90%",
};

const containerStyle = {
  position: "relative",
  display: "inline-block",
  textAlign: "center",
};

const imageStyle = {
  width: 500,
  height: 500,
  objectFit: "cover",
  display: "block",
};

const thumbWrapStyle = {
  position: "relative",
  width: 150,
  height: 150,
  overflow: "hidden",
  borderRadius: 8,
};

const thumbImageStyle = {
  width: 150,
  height: 150,
  objectFit: "cover",
  borderRadius: 8,
};

const trashIconStyle = {
  position: "absolute",
  top: 5,
  right: 5,
  color: "red",
  backgroundColor: "white",
  borderRadius: "50%",
  padding: 5,
  cursor: "pointer",
  boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.3)",
};

const thumbLabelStyle = {
  position: "absolute",
  bottom: 1,
  left: "50%",
  transform: "translate(-50%, -50%)",
  color: "rgba(255, 255, 255, 0.9)",
  backgroundColor: "rgba(0, 0, 0, 0.6)",
  borderRadius: 8,
  padding: "5px 10px",
  textAlign: "center",
  fontWeight: "bold",
  whiteSpace: "nowrap",
  maxWidth: 140,
  overflow: "hidden",
  textOverflow: "ellipsis",
};
